// extracted by mini-css-extract-plugin
export var container = "_4z-0";
export var disabled = "_4z-4";
export var fullWidth = "_4z-3";
export var lined = "_4z-1";
export var selected = "_4z-5";
export var tab = "_4z-2";